import React, { useEffect, useState } from "react";
import { TreeViewForMapStructure } from "./tree-our-node/tree-view-selected-data-flat-map";
import { TreeViewForFilteredDataNewStructure } from "./tree-our-node/tree-view-filtered-data-new-structure";
import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";

const TreeViewInitialStructure = () => {
  const [showFilterPanel, setShowFilterPanel] = useState(false);

  const initialStructureNodeset = getInitialStructureNodeset();

  useEffect(() => {
    const updateFilterFlatMap = () => {
      setShowFilterPanel(initialStructureNodeset.getShowFilterPanel());
    };

    initialStructureNodeset.addObserver(updateFilterFlatMap);

    return () => {
      initialStructureNodeset.removeObserver(updateFilterFlatMap);
    };
  }, [initialStructureNodeset]);

  const conditions = [
    {
      condition: showFilterPanel,
      component: <TreeViewForFilteredDataNewStructure />,
    },
    {
      condition: !showFilterPanel,
      component: <TreeViewForMapStructure />,
    },
  ];

  return <>{conditions.find(({ condition }) => condition)?.component}</>;
};

export default TreeViewInitialStructure;
